export default __webpack_public_path__ + "static/media/cykairos.72460bb0.png";